import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  auctions: [],
  auction: null,
  adminAuctions: [],
  total: 0,
  pages: 0,
  error: null,
  success: false,
  message: null,
};

export const auctionReducer = createReducer(initialState, {
  getAllAuctionsRequest: (state) => { state.isLoading = true; },
  getAllAuctionsSuccess: (state, action) => {
    state.isLoading = false;
    state.auctions = action.payload.auctions;
    state.total = action.payload.total;
    state.pages = action.payload.pages;
  },
  getAllAuctionsFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  getAuctionRequest: (state) => { state.isLoading = true; },
  getAuctionSuccess: (state, action) => {
    state.isLoading = false;
    state.auction = action.payload;
  },
  getAuctionFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  placeBidRequest: (state) => { state.isLoading = true; },
  placeBidSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.message = action.payload.message;
  },
  placeBidFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  getAdminAuctionsRequest: (state) => { state.isLoading = true; },
  getAdminAuctionsSuccess: (state, action) => {
    state.isLoading = false;
    state.adminAuctions = action.payload.auctions;
    state.total = action.payload.total;
    state.pages = action.payload.pages;
  },
  getAdminAuctionsFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  createAuctionRequest: (state) => { state.isLoading = true; },
  createAuctionSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.auction = action.payload;
  },
  createAuctionFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  endAuctionRequest: (state) => { state.isLoading = true; },
  endAuctionSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.message = action.payload.message;
  },
  endAuctionFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  clearAuctionErrors: (state) => { state.error = null; },
  clearAuctionSuccess: (state) => { state.success = false; state.message = null; },
});
